var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5446 6.5C13.5446 7.32843 12.9125 8 12.1328 8C11.3531 8 10.721 7.32843 10.721 6.5C10.721 5.67157 11.3531 5 12.1328 5C12.9125 5 13.5446 5.67157 13.5446 6.5Z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5446 18.5C13.5446 19.3284 12.9125 20 12.1328 20C11.3531 20 10.721 19.3284 10.721 18.5C10.721 17.6716 11.3531 17 12.1328 17C12.9125 17 13.5446 17.6716 13.5446 18.5Z",
    fill: "#979797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95634 12.5C6.95634 13.3284 6.32427 14 5.54458 14C4.76488 14 4.13281 13.3284 4.13281 12.5C4.13281 11.6716 4.76488 11 5.54458 11C6.32427 11 6.95634 11.6716 6.95634 12.5Z",
    fill: "#979797"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1328 12.5C20.1328 13.3284 19.5007 14 18.721 14C17.9414 14 17.3093 13.3284 17.3093 12.5C17.3093 11.6716 17.9414 11 18.721 11C19.5007 11 20.1328 11.6716 20.1328 12.5Z",
    fill: "#979797"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6622 7L6.01517 12M11.6622 18L6.01517 13M12.6034 7L18.2505 12M12.6034 18L18.2505 13M13.5446 6.5C13.5446 7.32843 12.9125 8 12.1328 8C11.3531 8 10.721 7.32843 10.721 6.5C10.721 5.67157 11.3531 5 12.1328 5C12.9125 5 13.5446 5.67157 13.5446 6.5ZM13.5446 18.5C13.5446 19.3284 12.9125 20 12.1328 20C11.3531 20 10.721 19.3284 10.721 18.5C10.721 17.6716 11.3531 17 12.1328 17C12.9125 17 13.5446 17.6716 13.5446 18.5ZM6.95634 12.5C6.95634 13.3284 6.32427 14 5.54458 14C4.76488 14 4.13281 13.3284 4.13281 12.5C4.13281 11.6716 4.76488 11 5.54458 11C6.32427 11 6.95634 11.6716 6.95634 12.5ZM20.1328 12.5C20.1328 13.3284 19.5007 14 18.721 14C17.9414 14 17.3093 13.3284 17.3093 12.5C17.3093 11.6716 17.9414 11 18.721 11C19.5007 11 20.1328 11.6716 20.1328 12.5Z",
    stroke: "#979797",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArea);
export default __webpack_public_path__ + "static/media/area.7eec4b62a7e49a8584fb5c43898656ff.svg";
export { ForwardRef as ReactComponent };